import { RowSelection$1, Table, Row, Cell, Column } from "./Table.fs.js";
import { empty as empty_1, map, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { createElement } from "react";
import React from "react";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { op_PlusPlus } from "../fable_modules/Feliz.Bulma.3.0.0/Operators.fs.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { unwrap } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { FSharpMap__TryFind } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { adminContent, dateTimeCell } from "./Prelude.fs.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { count, many } from "../Api/Users.fs.js";
import { AddUserToProject, RemoveFromProject, ChangePermissions } from "../Modals/User.fs.js";

const columns = ofArray([new Column("name", "Name", undefined), new Column("email", "Email", undefined), new Column("permissions", "Permissions", undefined), new Column("lastModified", "Last Modified", undefined)]);

function scopeToTag(isGlobal, scope) {
    let elems, copyOfStruct;
    const elms = singleton_1(createElement("div", createObj(Helpers_combineClasses("tags", ofArray([["className", "has-addons"], (elems = [createElement("abbr", createObj(toList(delay(() => append(singleton(op_PlusPlus(["className", join(" ", ["tag"])], ["className", "is-info"])), delay(() => (isGlobal ? append(singleton(["children", "G"]), delay(() => singleton(["title", "Global Permission"]))) : append(singleton(["children", "P"]), delay(() => singleton(["title", "Project Specific Permission"])))))))))), createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-light"], ["children", (copyOfStruct = scope, toString(copyOfStruct))]]))))], ["children", reactApi.Children.toArray(Array.from(elems))])])))));
    return createElement("div", {
        className: "control",
        children: reactApi.Children.toArray(Array.from(elms)),
    });
}

export function Permissions(permissionsInputProps) {
    let elems;
    const projectOpt = permissionsInputProps.projectOpt;
    const globalPermissions = permissionsInputProps.globalPermissions;
    return createElement("div", createObj(Helpers_combineClasses("field", ofArray([["className", "is-grouped"], ["className", "is-grouped-multiline"], (elems = toList(delay(() => append(map((scope) => scopeToTag(true, scope), globalPermissions), delay(() => {
        const matchValue = projectOpt;
        if (matchValue == null) {
            return empty();
        }
        else {
            return map((scope_1) => scopeToTag(false, scope_1), matchValue.Permissions);
        }
    })))), ["children", reactApi.Children.toArray(Array.from(elems))])]))));
}

function rowRender(projectId, user) {
    return new Row(user.Id, ofArray([new Cell("name", user.Name), new Cell("email", user.Email), new Cell("permissions", createElement(Permissions, {
        globalPermissions: user.GlobalPermissions,
        projectOpt: unwrap(FSharpMap__TryFind(user.Projects, projectId)),
    })), new Cell("lastModified", dateTimeCell(user.LastModified))]));
}

export function Users(usersInputProps) {
    let actions, user_1, user_2;
    const projectId = usersInputProps.projectId;
    const patternInput = reactApi.useState(undefined);
    const setAction = patternInput[1];
    const action = patternInput[0];
    const patternInput_1 = reactApi.useState("");
    const patternInput_2 = reactApi.useState(empty_1());
    const patternInput_3 = reactApi.useState(undefined);
    const selectedUser = patternInput_3[0];
    const close = reactApi.useCallback((hasChanges) => {
        let copyOfStruct;
        setAction(undefined);
        if (hasChanges) {
            patternInput_1[1]((copyOfStruct = utcNow(), toString(copyOfStruct)));
        }
    }, []);
    const table = createElement(Table, {
        name: "Users",
        columns: columns,
        initialFilters: empty_1(),
        onFiltersChange: patternInput_2[1],
        fetchData: (apiParams) => many(projectId, apiParams),
        fetchCount: (apiParams_1) => count(projectId, apiParams_1),
        rowRender: (user) => rowRender(projectId, user),
        refresh: patternInput_1[0],
        rowSelection: new RowSelection$1(1, [patternInput_3[1]]),
    });
    return adminContent(ofArray([createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Add User To Project"], ["onClick", (_arg) => {
        setAction("addUserToProject");
    }], ["disabled", selectedUser != null]])))), createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Permissions"], ["onClick", (_arg_1) => {
        setAction("update");
    }], ["disabled", selectedUser == null]])))), createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "Remove User From Project"], ["onClick", (_arg_2) => {
        setAction("removeUserFromProject");
    }], ["disabled", selectedUser == null]]))))]), table, (action != null) ? ((actions = action, (actions === "update") ? ((selectedUser != null) ? ((user_1 = selectedUser, createElement(ChangePermissions, {
        projectId: projectId,
        user: user_1,
        close: close,
    }))) : undefined) : ((actions === "removeUserFromProject") ? ((selectedUser != null) ? ((user_2 = selectedUser, createElement(RemoveFromProject, {
        projectId: projectId,
        user: user_2,
        close: close,
    }))) : undefined) : ((selectedUser == null) ? createElement(AddUserToProject, {
        projectId: projectId,
        close: close,
    }) : undefined)))) : undefined);
}

